export default __webpack_public_path__ + "static/media/COMFY COLLAGE.a112776e.png";